const goBack = (router) => {
  // 返回
  console.log('返回', window.history)
  if (window.history.length > 1) {
    router.back();
  } else {
    router.replace({
      path: `/rank`,
    });
  }
}

const goHome = (router) => {
  router.replace({
    path: `/home`,
  });
}

const goRank = (router) => {
  router.replace({
    path: `/rank`,
  });
}

export {
  goBack,
  goHome,
  goRank,
};
